
//define constants for reducer here

export const POST_ENQUIRY_REQUEST = 'POST_ENQUIRY_REQUEST '
export const POST_ENQUIRY_SUCCESS = 'POST_ENQUIRY_SUCCESS'
export const POST_ENQUIRY_FAIL = 'POST_ENQUIRY_FAIL'

export default {
    POST_ENQUIRY_REQUEST,
    POST_ENQUIRY_SUCCESS,
    POST_ENQUIRY_FAIL,
    reducerName: 'enquiry'
}


// WEBPACK FOOTER //
// ./src/redux-modules/enquiry/EnquiryConstants.js